// extracted by mini-css-extract-plugin
module.exports = {"block":"SpecBlock_block__0rHPk","blockHasBorder":"SpecBlock_blockHasBorder__FCwvl","active":"SpecBlock_active__Y_05Q"};